// src/components/Services/Services_CloudComputing.jsx
import React from 'react';
import { motion } from 'framer-motion';
import cloudGif from '../images/photos/cloud manag 1.gif'; // ✅ Check path

const pageVariants = {
  initial: { rotateY: 90, opacity: 0 },
  in: { rotateY: 0, opacity: 1 },
  out: { rotateY: -90, opacity: 0 },
};

const pageTransition = {
  type: 'spring',
  stiffness: 80,
  damping: 20,
};

const fadeUp = {
  hidden: { y: 10, opacity: 0 },
  visible: (i = 0) => ({
    y: 0,
    opacity: 1,
    transition: { delay: 0.06 * i },
  }),
};

export default function Services_CloudComputing() {
  const services = [
    'Android Zero Touch Enrollment',
    'Android Management',
    'Cloud Computing',
    'Cloud Management Service',
    'Cyber Security',
    'iOS Management',
    'Mobile Management',
    'IT Management',
    'IT Support',
    'Software Development',
    'Digital Marketing',
  ];

  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
      style={{
        minHeight: '100vh',
        background: '#040d1fff',
        color: '#e5e9edff',
        padding: '32px 16px',
      }}
    >
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        {/* HERO SECTION */}
        <section
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 32,
            alignItems: 'center',
          }}
        >
          {/* LEFT - GIF */}
          <motion.div initial="hidden" animate="visible" variants={fadeUp} custom={0}>
            <img
              src={cloudGif}
              alt="Cloud computing demo"
              style={{
                width: '100%',
                maxWidth: 500,
                height: 'auto',
                borderRadius: 12,
                boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
              }}
              loading="lazy"
            />
          </motion.div>

          {/* RIGHT - TEXT */}
          <motion.div initial="hidden" animate="visible" variants={fadeUp} custom={1}>
            <h1
              style={{
                marginTop: 0,
                fontSize: 'clamp(1.8rem, 3vw, 2.5rem)',
                color: '#6dd4e8ff',
              }}
            >
              Cloud Computing
            </h1>
            <p style={{ lineHeight: 1.6, color: '#e2e8f0', fontSize: 'clamp(0.95rem, 1.2vw, 1.1rem)' }}>
              At Zyntro, we deliver enterprise-grade Cloud Computing solutions designed to
              modernize and scale your business. From infrastructure to applications, our
              services ensure seamless integration, high availability, and optimized costs.
            </p>

            <h3
              style={{
                marginTop: 16,
                color: '#53bdd2ff',
                fontSize: 'clamp(1.2rem, 2vw, 1.5rem)',
              }}
            >
              Our Cloud Computing Services
            </h3>
            <ul
              style={{
                lineHeight: 1.7,
                color: '#f1f5f9',
                fontSize: 'clamp(0.9rem, 1vw, 1rem)',
                paddingLeft: 18,
              }}
            >
              <li><strong>IaaS</strong> — servers, storage & networking.</li>
              <li><strong>PaaS</strong> — build, test, deploy apps easily.</li>
              <li><strong>SaaS</strong> — cloud-hosted apps like Google Workspace, M365.</li>
              <li><strong>Cloud Security</strong> — encryption, monitoring & compliance.</li>
              <li><strong>Disaster Recovery</strong> — reliable backups & quick recovery.</li>
              <li><strong>Cloud Migration</strong> — seamless workload transition.</li>
              <li><strong>24/7 Support</strong> — expert monitoring & guidance.</li>
            </ul>

            {/* Buttons */}
            <div
              style={{
                marginTop: 18,
                display: 'flex',
                gap: 12,
                flexWrap: 'wrap',
              }}
            >
              <a
                href="mailto:support@zyntro.in"
                style={{
                  background: '#f69f48ff',
                  color: 'white',
                  padding: '10px 16px',
                  borderRadius: 8,
                  textDecoration: 'none',
                  fontWeight: 600,
                }}
              >
                Email Support
              </a>
              <a
                href="tel:+919956353236"
                style={{
                  border: '1px solid #4e4e54ff',
                  color: '#010101ff',
                  padding: '10px 16px',
                  borderRadius: 8,
                  textDecoration: 'none',
                  fontWeight: 600,
                  background: 'white',
                }}
              >
                Call +91-9956353236
              </a>
            </div>
          </motion.div>
        </section>

        {/* OTHER SERVICES */}
        <section style={{ marginTop: 40 }}>
          <h3 style={{ color: '#4fe1f4ff', fontSize: 'clamp(1.2rem, 2vw, 1.6rem)' }}>
            Other Services
          </h3>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
              gap: 16,
              marginTop: 16,
            }}
          >
            {services.map((s) => (
              <div
                key={s}
                style={{
                  background: '#1e293b',
                  padding: 12,
                  borderRadius: 8,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                }}
              >
                <div
                  style={{
                    width: 34,
                    height: 34,
                    borderRadius: 8,
                    background: '#1e7d95ff',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 700,
                    fontSize: 14,
                  }}
                >
                  {s.charAt(0)}
                </div>
                <span style={{ fontSize: 'clamp(0.85rem, 1vw, 1rem)' }}>{s}</span>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* ✅ Mobile responsiveness with inline CSS */}
      <style>
        {`
          @media (max-width: 768px) {
            section {
              grid-template-columns: 1fr !important;
              text-align: center;
            }
            section img {
              margin: 0 auto 20px;
            }
          }
        `}
      </style>
    </motion.div>
  );
}
